import React, { ComponentProps, FC } from "react";
import { withStyles } from "@material-ui/core/styles";
import { Badge } from "@material-ui/core";

interface IBlinkingDotProps extends ComponentProps<any> {
  isVisible: boolean;
}

const StyledBadge = withStyles((theme) => ({
  badge: {
    width: 10,
    height: 10,
    borderRadius: "50%",
    backgroundColor: theme.palette.error.main,
    color: theme.palette.error.main,
    boxShadow: `0 0 0 3px ${theme.palette.background.paper}`,
    "&::after": {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      borderRadius: "50%",
      animation: "$ripple 1.2s infinite ease-in-out",
      border: "1px solid currentColor",
      content: '""',
    },
    "&.MuiBadge-anchorOriginTopRightCircle": {
      top: "4px",
      right: "21%",
    },
  },
  "@keyframes ripple": {
    "0%": {
      transform: "scale(.8)",
      opacity: 1,
    },
    "100%": {
      transform: "scale(2.4)",
      opacity: 0,
    },
  },
}))(Badge);

const BlinkingDot: FC<IBlinkingDotProps> = ({ isVisible, children }) => (
  <StyledBadge
    invisible={!isVisible}
    overlap={"circle"}
    anchorOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    variant="dot"
  >
    {children}
  </StyledBadge>
);

export default BlinkingDot;
